import { UsersGroupIcon } from '@tableau/icons/UsersGroupIcon';
import { ButtonType, DialogFooterButtonsWidget, DialogPositioningBehavior, DialogType, DialogWidget, TextLinkWidget } from '@tableau/widgets';
import React, { ReactElement} from 'react';
import { classes } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { IGroupInfo } from '~src/userManagement/groups/models/IGroupInfo';

import { sendDashboardQABetaTermsAcceptedTelemetry } from './AgentBetaTelemetry';
import { styles } from './AgentSectionStyles';
import { getTestId } from './AgentSectionsUtils';
import { Agent } from './AgentSectionTypes';

const getGroupContent = (group: IGroupInfo) => <>{group.isAllUsersGroup ? null : <UsersGroupIcon size={14} className={classes(styles.icon, styles.groupIcon)}/>}{(group.name ?? group.groupLuid)}</>;
const LEGAL_LINK = 'https://www.salesforce.com/company/legal/';
export interface AgentBetaWarningDialogProps{
    agent: Agent;
    groups: IGroupInfo[];
    handleClose: () => void;
    activate: () => void;
}


export const AgentBetaWarningDialog = ({agent: agent, groups, handleClose, activate}: AgentBetaWarningDialogProps): ReactElement => {
    const body = Messages.settings_agents_beta_agreement_body({AGREEMENTS_LINK: 'XXXXXX'}).split('XXXXXX');
    const aggreementLink = <TextLinkWidget href={LEGAL_LINK} target="_blank" testId={getTestId('beta_legal_link')}>{Messages.settings_agents_beta_agreement_link_text()}</TextLinkWidget>;
    return <DialogWidget
            type={DialogType.NormalWithTitleBar}
            title={Messages.settings_agents_beta_agreement_title()}
            testId={getTestId('AgentBetaWarningDialog')}
            showCloseButton={true}
            onCloseRequest={handleClose}
            dialogWidth={400}
            positioningBehavior={DialogPositioningBehavior.Centered}
            footerContent={<DialogFooterButtonsWidget buttons={[
                {
                    buttonType: ButtonType.Outline,
                    testId: getTestId('AgentBetaWarningDialog_button_cancel'),
                    onClick: handleClose,
                    children: Messages.cancel(),
                },
                {
                    buttonType: ButtonType.Primary,
                    testId: getTestId('AgentBetaWarningDialog_button_turn_on'),
                    onClick: () => {sendDashboardQABetaTermsAcceptedTelemetry(); activate(); handleClose();},
                    children: Messages.settings_agents_beta_agreement_turn_on(),
                },
            ]} />}
            handleGlassClick={handleClose}
            isModal={true}>
            <div>
                {body[0]}{aggreementLink}{body[1]}
            </div>

            </DialogWidget>;
};